/** @format */

import React from 'react';

export const MegaMenuGraphics = ({onMouseLeave, onMouseOver, isMobile, display = 'none'}) => {
    const graphicDesignLinks = {
        base: '/design',
        edits: '/design#artworkedits',
        recreation: '/design#artworkrecreation',
        custom: '/design#customdesign',
        orders: '/orders/custom-design#get-started'
    };

    return (
        <div
            className="header-23cr_megamenus-toggler megamenus-toggler--graphics"
            onMouseLeave={!isMobile ? onMouseLeave : null}
            onMouseOver={!isMobile ? onMouseOver : null}
            style={{display}}>
            <nav
                aria-labelledby="sub-nav"
                className="header-23cr_megamenu-container megamenu-container-graphics">
                <div className="header-23cr_megamenu">
                    <div className="megamenu-23cr_links">
                        {/*  Image Lnk*/}
                        <div className="links-23cr_link link-image">
                            <div className="link-23cr_title">
                                <h3>
                                    <a href={graphicDesignLinks['base']}>
                                        Product Packaging Design
                                    </a>
                                </h3>
                                <span className="title-23cr_carat">
                                    <svg
                                        width="8"
                                        height="5"
                                        viewBox="0 0 8 5"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.166687L4 4.16669L8 0.166687H0Z" />
                                    </svg>
                                </span>
                            </div>
                            <div
                                className="link-image-23cr_image"
                                style={{
                                    backgroundImage: `linear-gradient(0deg, rgba(20, 20, 20, 0.55), rgba(20, 20, 20, 0.55)),  url('/images/header_footer/products_graphic_design.webp')`
                                }}>
                                <a href={graphicDesignLinks['orders']}>
                                    <h6>Find Out More</h6>
                                </a>
                            </div>
                        </div>

                        {/*  Product Types */}
                        <div className="links-23cr_link">
                            <div className="link-23cr_title">
                                <h3>
                                    <a href={graphicDesignLinks['orders']}>Design Offerings</a>
                                </h3>
                                <span className="title-23cr_carat">
                                    <svg
                                        width="8"
                                        height="5"
                                        viewBox="0 0 8 5"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.166687L4 4.16669L8 0.166687H0Z" />
                                    </svg>
                                </span>
                            </div>
                            <div className="link-23cr_links-list">
                                {/* first column*/}
                                <ul className="links-list-23cr_column column-first">
                                    <li>
                                        <h6>Label & Carton Design</h6>
                                    </li>
                                    <li>
                                        <a
                                            href={`${graphicDesignLinks['edits']}`}
                                            className="d-block">
                                            Artwork Edits
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${graphicDesignLinks['recreation']}`}
                                            className="d-block">
                                            Artwork Recreation
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${graphicDesignLinks['custom']}`}
                                            className="d-block">
                                            Custom Label Design
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
};
